export default "__VITE_ASSET__95e5511f__"